/**
 * AuthAwareSupportLayout — Phase 152.Z.
 *
 * The Classroom Support area (`/classroom-support` + the 4 profile
 * pages) was originally built as a public, no-login marketing surface
 * — top bar reads "← Atomic Edu" / "Free · No login". When a teacher
 * is signed in, that chrome is wrong: they should see the standard
 * AppShell (left rail + three-bar mobile menu + InPageTopBar with
 * "Classroom Support" as the title) so they can navigate to other
 * features the way they would from any other in-app page.
 *
 * This wrapper:
 *   - When `signedIn` → renders the content inside `<AppShell title="Classroom Support">`
 *     (the public top bar is suppressed by passing `showPublicTopBar={false}`
 *     to the child via render-prop pattern).
 *   - When NOT signed in → renders the content directly (the page
 *     emits its own public top bar as before).
 *
 * The page calls this as a function child so it can decide whether to
 * render its own top bar:
 *
 *   <AuthAwareSupportLayout title="Classroom Support">
 *     {({ inShell }) => (
 *       <>
 *         {!inShell ? <PublicTopBar /> : null}
 *         <main>…</main>
 *       </>
 *     )}
 *   </AuthAwareSupportLayout>
 */
import { useAuth } from "../../contexts/AuthContext";
import { AppShell } from "../shell/AppShell";

export default function AuthAwareSupportLayout({ title = "Classroom Support", children }) {
  const { user } = useAuth();
  const signedIn = !!user;

  if (signedIn) {
    return <AppShell title={title}>{children({ inShell: true })}</AppShell>;
  }
  return <>{children({ inShell: false })}</>;
}
